import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Order } from '../../../../shared/objects/order/order';
import { InstructionDocsService } from '../../instruction-docs/share/instruction-docs.service';
import { FileElement } from '../../instruction-docs/share/fileElement.model';
import { CommonUtils } from '../../../../shared/utils/common.utils';
import { OrderStatus } from '../../../../shared/objects/enum/orderStatus';
import { GlobalResponsivenessService } from '../../../../core/services/global-responsiveness.service';
import { MatTooltip as MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs-compat/Subscription';

@Component({
    selector: 'app-order-more-information',
    templateUrl: './order-more-information.component.html',
    styleUrls: ['./order-more-information.component.css'],
    standalone: false
})
export class OrderMoreInformationComponent implements OnInit, OnDestroy {
  @Input() remark;
  @Input() customerName;
  @Input() isOrderDetails = false;
  isDesktop = true;
  moreInfoIsCollapsed = false;
  instructionDocs: FileElement[];
  commonUtils = CommonUtils;
  nameLimit: number = 60;
  cleanOrderCustomerName: string;
  sub: Subscription;
  get customerHasIntructionDocs(): boolean {
    return !!this.instructionDocs && this.instructionDocs.length > 0;
  }
  get infoLabel(): string {
    return this.isOrderDetails
      ? this.translateService.instant('INSTRUCTION-DOCS.REMARKS-TAB')
      : this.translateService.instant(
          'FREIGHT-EXCHANGE-DETAILS.TITLE-INSTRUCTIONS',
        );
  }
  constructor(
    private instructionService: InstructionDocsService,
    private globalResponsivenessService: GlobalResponsivenessService,
    private translateService: TranslateService,
  ) {
    const currentResolution =
      this.globalResponsivenessService.getCurrentResolution();
    if (
      currentResolution == '1920x969' ||
      currentResolution == '1280x913' ||
      currentResolution == '1280x609'
    ) {
      this.isDesktop = true;
      this.nameLimit = 25;
    } else {
      this.isDesktop = false;
    }
    if (currentResolution == '360x640') {
      this.nameLimit = 20;
    }
    this.sub = this.globalResponsivenessService.isDesktop$.subscribe(
      isDesktop => {
        this.isDesktop = isDesktop;
      },
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
  async ngOnInit() {
    if (!this.customerName) {
      return;
    }
    this.instructionDocs = await this.instructionService.getAll();
    this.cleanOrderCustomerName = this.instructionService.cleanDirectoryName(
      this.customerName,
    );
    const parentId = this.instructionDocs
      .filter(
        f =>
          this.instructionService.cleanDirectoryName(f.name).toLowerCase() ===
          this.cleanOrderCustomerName.toLowerCase(),
      )
      .map(f => f.id)[0];
    this.instructionDocs = this.instructionDocs.filter(
      f => !f.isFolder && f.parent === parentId,
    );
    this.globalResponsivenessService.docNameLimit$.subscribe(value => {
      this.nameLimit = value;
    });
  }

  public toggleTooltip(tooltip: MatTooltip): void {
    tooltip.toggle();
  }

  formatName(name: string): string {
    return name.length > this.nameLimit
      ? `${name.substr(0, this.nameLimit)}...`
      : name;
  }

  scrollElementIntoView(element) {
    setTimeout(() => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'end',
      });
    }, 250);
  }

  toggleMoreInfoCollapse() {
    this.moreInfoIsCollapsed = !this.moreInfoIsCollapsed;
    if (!this.moreInfoIsCollapsed) {
      const moreInfo = document.getElementById('moreInfoContainer');
      const collapse = document.getElementById('collapseMoreInfo');
      const container = moreInfo ? moreInfo : collapse;
      this.scrollElementIntoView(container);
    }
  }

  view(element: FileElement): void {
    const fileElement: FileElement = {
      name: element.name,
      isFolder: false,
      parent: this.cleanOrderCustomerName,
    };
    this.instructionService.view(fileElement);
  }
}
